import { render, staticRenderFns } from "./StockTableHeader.vue?vue&type=template&id=6df2255a"
import script from "./StockTableHeader.vue?vue&type=script&lang=js"
export * from "./StockTableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports